<script setup lang="ts">
import { onMounted } from 'vue';
import { useState } from './composables/useState.ts';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import { useLogger } from './composables/useLogger.ts';
import { useRoute } from 'vue-router';

const { setUsername } = useState();
const { log } = useLogger();
const route = useRoute();

onMounted(() => {
  log('on mounted app');

  const localStorageUsername = localStorage.getItem('username');
  if (localStorageUsername) {
    setUsername(localStorageUsername);
  }
});
</script>

<template>
  <Header />

  <main class="flex-grow" :class="{ 'min-h-0': route.name === 'room' }">
    <RouterView />
  </main>

  <Footer />
</template>
